import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

const API_TV = '/api/tv';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('plan_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await fetch(`${API_TV}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setUser(data.user || data);
      } else {
        localStorage.removeItem('plan_token');
      }
    } catch (e) {
      localStorage.removeItem('plan_token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    const res = await fetch(`${API_TV}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Login failed');
    localStorage.setItem('plan_token', data.token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('plan_token');
    setUser(null);
  }, []);

  const isAdmin    = user?.role === 'admin';
  const isManager  = ['admin','manager','senior'].includes(user?.role);
  const canEdit    = ['admin','manager','senior','junior'].includes(user?.role);
  const canApprove = ['admin','manager'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isManager, canEdit, canApprove }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
